export type ThresholdProps = {
  value: number;
  showIndicator?: boolean;
  color?: string;
};

export const findMatchingThreshold = (
  value: number,
  thresholds: ThresholdProps[],
): ThresholdProps | undefined => {
  const filteredThresholdData = thresholds.filter(
    (threshold) => value >= threshold.value,
  );

  if (!filteredThresholdData.length) {
    return undefined;
  }

  return filteredThresholdData.reduce(
    (final, current) => (current.value > final.value ? current : final),
    filteredThresholdData[0],
  );
};
